import AssetThumbnail from '@admin/components/asset_thumbnail'
import PropTypes from 'prop-types'
import React from 'react'


const EmailCampaignCard = ({ asset }) => (
  <div className="maha-card-layout-card-body">
    <div className="maha-card-layout-card-screenshot">
      <AssetThumbnail { ...asset } width={ 200 } />
    </div>
  </div>
)

EmailCampaignCard.propTypes = {
  asset: PropTypes.object
}

export default EmailCampaignCard
